import { VerticalFormGroupSkeleton } from 'components/shared/FormGroup';
import { FC } from 'react';

export const DetailsSkeleton: FC = () => (
  <div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={8} className="col-6" />
      <VerticalFormGroupSkeleton labelSize={10} className="col-6" />
    </div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={15} className="col-6" />
      <VerticalFormGroupSkeleton labelSize={12} className="col-6" />
    </div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={15} className="col-12" />
    </div>
    <div className="row">
      <VerticalFormGroupSkeleton labelSize={8} className="col-6" />
      <VerticalFormGroupSkeleton labelSize={8} className="col-6" />
    </div>
  </div>
);
